// Carousel: The Arrows
document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.querySelector(".carousel")
  const leftArrow = document.querySelector(".carousel-controls .left-arrow")
  const rightArrow = document.querySelector(".carousel-controls .right-arrow")

  const scrollAmount = carousel.offsetWidth // Amount to scroll (carousel width)

  // Check scroll position and update arrow classes
  const updateArrowClasses = () => {
    const scrollLeft = carousel.scrollLeft
    const maxScrollLeft = carousel.scrollWidth - carousel.offsetWidth

    // Check if at the start
    if (scrollLeft <= 0) {
      leftArrow.classList.add("disabled")
    } else {
      leftArrow.classList.remove("disabled")
    }

    // Check if at the end
    if (scrollLeft >= maxScrollLeft - 1) {
      rightArrow.classList.add("disabled")
    } else {
      rightArrow.classList.remove("disabled")
    }
  }

  // Scroll left
  leftArrow.addEventListener("click", () => {
    carousel.scrollBy({
      left: -scrollAmount,
      behavior: "smooth",
    })
    setTimeout(updateArrowClasses, 300) // Update classes after scrolling
  })

  // Scroll right
  rightArrow.addEventListener("click", () => {
    carousel.scrollBy({
      left: scrollAmount,
      behavior: "smooth",
    })
    setTimeout(updateArrowClasses, 300) // Update classes after scrolling
  })

  // Initial check for arrow states
  updateArrowClasses()

  // Add event listener for scroll to dynamically update arrow states
  carousel.addEventListener("scroll", updateArrowClasses)

  // ###################
  // Accessibility - Move with keyboard
  // const cards = document.querySelectorAll('.carousel .grid__item');
  // cards.forEach((card, idx) => {
  //   card.addEventListener('keydown', function (event) {
  //     if (event.key === 'ArrowRight') {
  //       event.preventDefault();
  //       if (idx < cards.length - 1) {
  //         cards[idx + 1].focus();
  //         cards[idx + 1].scrollIntoView({ behavior: 'smooth', inline: 'center' });
  //       }
  //     } else if (event.key === 'ArrowLeft') {
  //       event.preventDefault();
  //       if (idx > 0) {
  //         cards[idx - 1].focus();
  //         cards[idx - 1].scrollIntoView({ behavior: 'smooth', inline: 'center' });
  //       }
  //     }
  //   });
  // });
})
